import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  // INIT_URL,
  ON_USERS_LIST,
  // ON_USER_UPDATE_START,
  // ON_USER_UPDATE_ERROR,
  // ON_REGISTER_USER_DATA,
  // ON_USER_UPDATE,
  SHOW_MESSAGE,
  USER_DATA,
} from "../constants/ActionTypes";
import { adminAPI, ngoromsoAPI } from 'util/Api';

// import ngoromsoApi  from "util/ngoromsoApi";  
import { randomizePwd } from "util/Common";
import {
  //  userSignOut,
  getUserDetails
} from "./Auth";
import { store } from "MainApp";

//import axios from 'axios';

export const getUserList = () => {
  //console.log('Am here');
  let token = sessionStorage.getItem("token");
  const _data = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    //data: {}
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    ngoromsoAPI
      .get("users?NOPICS=1", _data)
      .then(({ data }) => {
        console.log('Success');
        console.log("Fetched Users: ", data);
        // let data = [
        //   {
        //     "ID": 1,
        //     "USERNAME": "norbert.kimario@gmail.com",
        //     "USER_ID": "norbert.kimario@gmail.com",
        //     "FIRST_NAME": "NORBERT",
        //     "MIDDLE_NAME": "DIDAS",
        //     "LAST_NAME": "KIMARIO",
        //     "EMAIL": "norbert.kimario@gmail.com",
        //     "PHONE": "0713719869",
        //     "BRANCH_CODE": "002",
        //     "BANK_CODE": "BK0003",
        //     "BANK_NAME": "CRDB LIMITED",
        //     "BRANCH_NAME": "MWANZA",
        //     "ROLE_ID": 7,
        //     "SCC_ID": 92,
        //     "USER_CATEGORY_ID": 7,
        //     "STATUS": "ACTIVE",
        //     "SESSION": "OFF",
        //     "FORCE_CHANGE_PASSWORD": 0,
        //     "RETRY_COUNT": 0,
        //     "APPROVED_BY": 0,
        //     "APPROVED_AT": null,
        //     "CREATED_AT": "2020-09-19T19:45:27.685Z",
        //     "CREATED_BY": 144,
        //     "UPDATED_AT": null,
        //     "UPDATED_BY": 144,
        //     "APPROVE_AMT_LIMIT": " ",
        //     "MFA_TYPE": null,
        //     "LAST_PASSWORD_CHANGE_DATE": "2022-08-30T07:11:29.504Z",
        //     "SCC_ID2": 92
        //   },
        //   {
        //     "ID": 2,
        //     "USERNAME": "samanangu@gmail.com",
        //     "USER_ID": "SAMANANGU",
        //     "FIRST_NAME": "SIMON",
        //     "MIDDLE_NAME": "AUGUSTIN",
        //     "LAST_NAME": "MALANGU",
        //     "EMAIL": "samanangu@gmail.com",
        //     "PHONE": "0653289887",
        //     "BRANCH_CODE": "002",
        //     "BANK_CODE": "BK0001",
        //     "BANK_NAME": "BANK OF TANZANIA",
        //     "BRANCH_NAME": "ARUSHA BRANCH",
        //     "ROLE_ID": 21,
        //     "SCC_ID": 1,
        //     "USER_CATEGORY_ID": 21,
        //     "STATUS": "ACTIVE",
        //     "SESSION": "ON",
        //     "FORCE_CHANGE_PASSWORD": 0,
        //     "RETRY_COUNT": 0,
        //     "APPROVED_BY": 1,
        //     "APPROVED_AT": null,
        //     "CREATED_AT": "2020-02-25T10:37:21.377Z",
        //     "CREATED_BY": 1,
        //     "UPDATED_AT": null,
        //     "UPDATED_BY": 442,
        //     "APPROVE_AMT_LIMIT": " ",
        //     "MFA_TYPE": null,
        //     "LAST_PASSWORD_CHANGE_DATE": "2022-08-30T07:11:29.504Z",
        //     "SCC_ID2": 93
        //   },
        //   {
        //     "ID": 3,
        //     "USERNAME": "mkmgina@gmail.com",
        //     "USER_ID": "MKMGINA",
        //     "FIRST_NAME": "MIRIAM",
        //     "MIDDLE_NAME": "K",
        //     "LAST_NAME": "MGINA",
        //     "EMAIL": "mkmgina@gmail.com",
        //     "PHONE": "0768493079",
        //     "BRANCH_CODE": "003",
        //     "BANK_CODE": "BK0001",
        //     "BANK_NAME": "BANK OF TANZANIA",
        //     "BRANCH_NAME": "MWANZA",
        //     "ROLE_ID": 5,
        //     "SCC_ID": 92,
        //     "USER_CATEGORY_ID": 5,
        //     "STATUS": "ACTIVE",
        //     "SESSION": "OFF",
        //     "FORCE_CHANGE_PASSWORD": 0,
        //     "RETRY_COUNT": 0,
        //     "APPROVED_BY": 0,
        //     "APPROVED_AT": null,
        //     "CREATED_AT": "2021-03-30T16:18:57.731Z",
        //     "CREATED_BY": 144,
        //     "UPDATED_AT": null,
        //     "UPDATED_BY": 144,
        //     "APPROVE_AMT_LIMIT": " ",
        //     "MFA_TYPE": null,
        //     "LAST_PASSWORD_CHANGE_DATE": "2022-08-30T07:11:29.504Z",
        //     "SCC_ID2": 92
        //   },
        //   {
        //     "ID": 4,
        //     "USERNAME": "sdkyaruzi@gmail.com",
        //     "USER_ID": "SDKYARUZI",
        //     "FIRST_NAME": "SWEETBERTHA",
        //     "MIDDLE_NAME": "D",
        //     "LAST_NAME": "KYARUZI",
        //     "EMAIL": "sdkyaruzi@gmail.com",
        //     "PHONE": "0754630928",
        //     "BRANCH_CODE": "003",
        //     "BANK_CODE": "BK0001",
        //     "BANK_NAME": "BANK OF TANZANIA",
        //     "BRANCH_NAME": "MWANZA",
        //     "ROLE_ID": 5,
        //     "SCC_ID": 92,
        //     "USER_CATEGORY_ID": 5,
        //     "STATUS": "ACTIVE",
        //     "SESSION": "OFF",
        //     "FORCE_CHANGE_PASSWORD": 0,
        //     "RETRY_COUNT": 0,
        //     "APPROVED_BY": 0,
        //     "APPROVED_AT": null,
        //     "CREATED_AT": "2021-03-30T16:25:07.408Z",
        //     "CREATED_BY": 144,
        //     "UPDATED_AT": null,
        //     "UPDATED_BY": 145,
        //     "APPROVE_AMT_LIMIT": " ",
        //     "MFA_TYPE": null,
        //     "LAST_PASSWORD_CHANGE_DATE": "2022-08-30T07:11:29.504Z",
        //     "SCC_ID2": 92
        //   },
        //   {
        //     "ID": 5,
        //     "USERNAME": "smjeremiah@gmail.com",
        //     "USER_ID": "SMJEREMIAH",
        //     "FIRST_NAME": "SUBYEKI",
        //     "MIDDLE_NAME": "M",
        //     "LAST_NAME": "JEREMIAH",
        //     "EMAIL": "smjeremiah@gmail.com",
        //     "PHONE": "0754663631",
        //     "BRANCH_CODE": "003",
        //     "BANK_CODE": "BK0001",
        //     "BANK_NAME": "BANK OF TANZANIA",
        //     "BRANCH_NAME": "MWANZA",
        //     "ROLE_ID": 5,
        //     "SCC_ID": 92,
        //     "USER_CATEGORY_ID": 5,
        //     "STATUS": "ACTIVE",
        //     "SESSION": "OFF",
        //     "FORCE_CHANGE_PASSWORD": 0,
        //     "RETRY_COUNT": 0,
        //     "APPROVED_BY": 0,
        //     "APPROVED_AT": null,
        //     "CREATED_AT": "2021-03-30T16:27:48.519Z",
        //     "CREATED_BY": 144,
        //     "UPDATED_AT": null,
        //     "UPDATED_BY": 144,
        //     "APPROVE_AMT_LIMIT": " ",
        //     "MFA_TYPE": null,
        //     "LAST_PASSWORD_CHANGE_DATE": "2022-08-30T07:11:29.504Z",
        //     "SCC_ID2": 92
        //   },
        //   {
        //     "ID": 6,
        //     "USERNAME": "ssmasoud@gmail.com",
        //     "USER_ID": "SSMASOUD",
        //     "FIRST_NAME": "SULEIMAN",
        //     "MIDDLE_NAME": "S",
        //     "LAST_NAME": "MASOUD",
        //     "EMAIL": "ssmasoud@gmail.com",
        //     "PHONE": "0767021011",
        //     "BRANCH_CODE": "004",
        //     "BANK_CODE": "BK0001",
        //     "BANK_NAME": "BANK OF TANZANIA",
        //     "BRANCH_NAME": "ZANZIBAR BRANCH",
        //     "ROLE_ID": 6,
        //     "SCC_ID": 4,
        //     "USER_CATEGORY_ID": 6,
        //     "STATUS": "ACTIVE",
        //     "SESSION": "OFF",
        //     "FORCE_CHANGE_PASSWORD": 0,
        //     "RETRY_COUNT": 0,
        //     "APPROVED_BY": 0,
        //     "APPROVED_AT": null,
        //     "CREATED_AT": "2020-08-04T06:40:30.341Z",
        //     "CREATED_BY": 4,
        //     "UPDATED_AT": null,
        //     "UPDATED_BY": 145,
        //     "APPROVE_AMT_LIMIT": " ",
        //     "MFA_TYPE": null,
        //     "LAST_PASSWORD_CHANGE_DATE": "2023-10-25T05:48:43.200Z",
        //     "SCC_ID2": 98
        //   }
        // ]
        
        if (data.length) {
          dispatch({ type: FETCH_SUCCESS });
          // format data and store them for use..
          dispatch({ type: ON_USERS_LIST, payload: data });
        } else {
          dispatch({ type: FETCH_ERROR, payload: data.error });
        }
      })
      .catch(function (error) {
        //alert('Imegoma')
        //alert('Hapa Error'+JSON.stringify(error))
        //console.log('Not executing this one', error);
        dispatch({ type: FETCH_ERROR, payload: error.message });
        //console.log("Error****:", error.message);
      });
  };
};

export const getUserListCB = () => {
  //console.log('Am here');
  let token = sessionStorage.getItem("token");
  const _data = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    // data: {}
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI
      .get(
        "users?NOPICS=1&BANK_CODE=" +
        getUserDetails().BANK_CODE +
        "&BRANCH_CODE=" +
        getUserDetails().BRANCH_CODE,
        _data
      )
      .then(({ data }) => {
        //console.log('Success');
        //console.log("Fetched Users: ", data);
        if (data.length) {
          dispatch({ type: FETCH_SUCCESS });
          // format data and store them for use..
          dispatch({ type: ON_USERS_LIST, payload: data });
        } else {
          dispatch({ type: FETCH_ERROR, payload: data.error });
        }
      })
      .catch(function (error) {
        //alert('Hapa Error'+JSON.stringify(error))
        //console.log('Not executing this one', error);
        dispatch({ type: FETCH_ERROR, payload: error.message });
        //console.log("Error****:", error.message);
      });
  };
};

export const getUserListSCC = () => {
  //console.log('Am here');
  let token = sessionStorage.getItem("token");
  const _data = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    // data: {}
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI
      .get("users?NOPICS=1&SCC_ID=" + getUserDetails().SCC_ID, _data)
      .then(({ data }) => {
        // alert('Imeenda')
        //console.log('Success');
        //console.log("Fetched Users: ", data);
        if (data.length) {
          dispatch({ type: FETCH_SUCCESS });
          // format data and store them for use..
          dispatch({ type: ON_USERS_LIST, payload: data });
        } else {
          dispatch({ type: FETCH_ERROR, payload: data.error });
        }
      })
      .catch(function (error) {
        // alert('Imegoma')
        //alert('Hapa Error'+JSON.stringify(error))
        //console.log('Not executing this one', error);
        dispatch({ type: FETCH_ERROR, payload: error.message });
        //console.log("Error****:", error.message);
      });
  };
};

export const getUserInfo = (username) => {
  //console.log('Am here');
  let token = sessionStorage.getItem("token");

  const _data = {
    headers: {
      Authorization: `Bearer ${token}`
    }
    // data: {}
  };
  return async (dispatch) => {
    dispatch({ type: FETCH_START });
    await adminAPI
      .get("users?USERNAME=" + username, _data)
      .then(({ data }) => {
        //console.log('Success');
        //console.log("Fetched User details: ", data);
        if (data.length) {
          dispatch({ type: FETCH_SUCCESS });
          // format data and store them for use..
          dispatch({ type: ON_USERS_LIST, payload: data });
        } else {
          dispatch({ type: FETCH_ERROR, payload: data.error });
        }
      })
      .catch(function (error) {
        //alert('Hapa Error'+JSON.stringify(error))
        //console.log('Not executing this one', error);
        dispatch({ type: FETCH_ERROR, payload: error.message });
        //console.log("Error****:", error.message);
      });
  }
}

export const getUserBranch = (userId) => {
  //console.log('Am here');
  let token = sessionStorage.getItem("token");

  const _data = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    // data: {}
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI
      .get("users?USER_ID=" + userId, _data)
      .then(({ data }) => {
        //console.log('Success');
        //console.log("Fetched Users: ", data);
        if (data.length) {
          dispatch({ type: FETCH_SUCCESS });
          // format data and store them for use..
          dispatch({ type: ON_USERS_LIST, payload: data });
        } else {
          dispatch({ type: FETCH_ERROR, payload: "Failed to get user" });
        }
      })
      .catch(function (error) {
        //console.log('Not executing this one', error);
        dispatch({ type: FETCH_ERROR, payload: error.message });
        //console.log("Error****:", error.message);
      });
  };
};

export const createUser = (newUser) => {
  // console.log('newUser');
  // console.log(newUser);
  // console.log('newUser');
  newUser.custody_center = newUser.custody_center
    ? newUser.custody_center
    : "0";
  newUser.user_branch = newUser.user_branch ? newUser.user_branch : "0";

  let token = sessionStorage.getItem("token");

  const _data = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    // data: {}
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI
      .post(
        "users",
        {
          EMAIL: newUser.email ? newUser.email : null,
          MFA_TYPE: newUser.MFA_TYPE,
          USERNAME: newUser.email ? newUser.email : null,
          PASSWORD: randomizePwd(8), //'Mikum@i123',
          USER_ID: newUser.email
            ? newUser.email.split("@")[0].toUpperCase()
            : null,
          FIRST_NAME: newUser.First_Name
            ? newUser.First_Name.toUpperCase()
            : null,
          MIDDLE_NAME: newUser.Middle_Name
            ? newUser.Middle_Name.toUpperCase()
            : null,
          LAST_NAME: newUser.Last_Name ? newUser.Last_Name.toUpperCase() : null,
          SCC_ID: newUser.custody_center ? newUser.custody_center : 0,
          ROLE_ID: newUser.user_category ? newUser.user_category : null,
          PHONE: newUser.phone ? newUser.phone : null,
          BRANCH_CODE: newUser.user_branch.split("-")[0],
          BANK_CODE: newUser.user_branch.split("-")[1],
          USER_CATEGORY_ID: newUser.user_category
            ? newUser.user_category
            : null,
          PROFILE_PIC: newUser.PROFILE_PIC ? newUser.PROFILE_PIC : null,
          SIGNATURE_IMAGE: newUser.SIGNATURE_IMAGE
            ? newUser.SIGNATURE_IMAGE
            : null,
          BIO_INFO: newUser.BIO_INFO ? newUser.BIO_INFO : "BIO_INFO",
          STATUS: "ACTIVE",
          APPROVED_BY: "0",
          // APPROVE_AMT_LIMIT:(newUser.APPROVE_AMT_LIMIT)?newUser.APPROVE_AMT_LIMIT:0,
          APPROVE_AMT_LIMIT:
            newUser.user_category == 3
              ? "A"
              : newUser.user_category == 2
                ? "B"
                : " ",
          CREATED_BY: JSON.parse(sessionStorage.getItem("user")).ID,
          UPDATED_BY: JSON.parse(sessionStorage.getItem("user")).ID,
        },
        _data,
      )
      .then(({ data }) => {
        //console.log("data:", data);
        // console.log('success');
        sessionStorage.setItem("createUserResp", "success");
        // dispatch({type: FETCH_SUCCESS});
        // dispatch({type: ON_REGISTER_USER_DATA, payload: newUser});
        dispatch({ type: SHOW_MESSAGE, payload: "Successfully registered" });
      })
      .catch(function (error) {
        sessionStorage.setItem("createUserResp", "error");
        dispatch({ type: FETCH_ERROR, payload: "Failed to register" });
        // console.log("Error****:", error.message);
      });
  };
};

export const updateUser = (newUser) => {
  // alert(newUser.MFA_TYPE);

  // console.log('newUser');
  // console.log(newUser);
  // console.log('newUser');

  let token = sessionStorage.getItem("token");

  const _data = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    // data: {}
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI
      .put(
        "user/" + newUser.ID,
        {
          EMAIL: newUser.EMAIL,
          MFA_TYPE: (newUser.MFA_TYPE && newUser.MFA_TYPE !== "NONE") ? newUser.MFA_TYPE : "",
          //USERNAME:newUser.EMAIL,
          PASSWORD:
            newUser.RESET_PASSWORD && newUser.RESET_PASSWORD == "YES"
              ? randomizePwd(8)
              : newUser.PASSWORD
                ? newUser.PASSWORD
                : "",
          USER_ID: newUser.USER_ID,
          RESET_PASSWORD: newUser.RESET_PASSWORD,
          FIRST_NAME: newUser.FIRST_NAME
            ? newUser.FIRST_NAME.toUpperCase()
            : newUser.FIRST_NAME,
          MIDDLE_NAME: newUser.MIDDLE_NAME
            ? newUser.MIDDLE_NAME.toUpperCase()
            : newUser.MIDDLE_NAME,
          LAST_NAME: newUser.MIDDLE_NAME
            ? newUser.LAST_NAME.toUpperCase()
            : newUser.MIDDLE_NAME,
          //SCC_ID: (newUser.USER_CATEGORY_ID == 4 || newUser.USER_CATEGORY_ID == 8)?newUser.SCC_ID:0,
          SCC_ID: newUser.SCC_ID ? newUser.SCC_ID : 0,
          ROLE_ID:
            newUser.USER_CATEGORY_ID && !newUser.SELF
              ? newUser.USER_CATEGORY_ID
              : newUser.ROLE_ID,
          PHONE: newUser.PHONE,
          BRANCH_CODE: newUser.BRANCH_CODE.split("-")[0],
          BANK_CODE: newUser.BRANCH_CODE.split("-")[1],
          USER_CATEGORY_ID: newUser.USER_CATEGORY_ID,
          PROFILE_PIC: newUser.PROFILE_PIC ? newUser.PROFILE_PIC : "",
          SIGNATURE_IMAGE: newUser.SIGNATURE_IMAGE
            ? newUser.SIGNATURE_IMAGE
            : "",
          BIO_INFO: newUser.BIO_INFO ? newUser.BIO_INFO : "BIO_INFO",
          STATUS: newUser.STATUS ? newUser.STATUS : "ACTIVE",
          APPROVED_BY: newUser.APPROVED_BY,
          APPROVE_AMT_LIMIT:
            newUser.ROLE_ID == 3 ? "A" : newUser.ROLE_ID == 2 ? "B" : " ",
          UPDATED_BY: JSON.parse(sessionStorage.getItem("user")).ID,
        },
        _data,
      )
      .then(({ data }) => {
        //console.log("user data:", data);
        // console.log('success');
        //sessionStorage.setItem("createResp", 'success');
        //dispatch({type: FETCH_SUCCESS});
        // alert(JSON.stringify(store.getState().auth.authUser))
        let userInfo = store.getState().auth.authUser;
        userInfo.FORCE_CHANGE_PASSWORD = 0;
        sessionStorage.setItem("user", JSON.stringify(userInfo));
        dispatch({ type: USER_DATA, payload: userInfo });
        dispatch({ type: SHOW_MESSAGE, payload: "User updated successfully" });
        // dispatch({type: SHOW_MESSAGE, payload: "Successful"});
        //dispatch(userSignOut)
        //alert(JSON.stringify(store.getState().auth.authUser))
      })
      .catch(function (error) {
        //alert(JSON.stringify(error))
        //console.log("user data Failed: ");
        //sessionStorage.setItem("createResp", 'error');
        dispatch({ type: FETCH_ERROR, payload: "Failed to update user" });
        //console.log("Error****:", error.message);
      });
  };
};

export const updateUserPassword = (newUser) => {
  // console.log('newUser');
  // console.log(newUser);
  // console.log('newUser');

  let token = sessionStorage.getItem("token");

  const _data = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    // data: {}
  };
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    adminAPI
      .put(
        "user/" + newUser.ID,
        {
          EMAIL: newUser.EMAIL,
          //USERNAME:newUser.EMAIL,
          MFA_TYPE: (newUser.MFA_TYPE && newUser.MFA_TYPE !== "NONE") ? newUser.MFA_TYPE : "",
          PASSWORD:
            newUser.RESET_PASSWORD && newUser.RESET_PASSWORD == "YES"
              ? randomizePwd(8)
              : newUser.PASSWORD
                ? newUser.PASSWORD
                : "",
          USER_ID: newUser.USER_ID,
          RESET_PASSWORD: newUser.RESET_PASSWORD,
          FIRST_NAME: newUser.FIRST_NAME
            ? newUser.FIRST_NAME.toUpperCase()
            : newUser.FIRST_NAME,
          MIDDLE_NAME: newUser.MIDDLE_NAME
            ? newUser.MIDDLE_NAME.toUpperCase()
            : newUser.MIDDLE_NAME,
          LAST_NAME: newUser.MIDDLE_NAME
            ? newUser.LAST_NAME.toUpperCase()
            : newUser.MIDDLE_NAME,
          //SCC_ID: (newUser.USER_CATEGORY_ID == 4 || newUser.USER_CATEGORY_ID == 8)?newUser.SCC_ID:0,
          SCC_ID: newUser.SCC_ID ? newUser.SCC_ID : 0,
          ROLE_ID:
            newUser.USER_CATEGORY_ID && !newUser.SELF
              ? newUser.USER_CATEGORY_ID
              : newUser.ROLE_ID,
          PHONE: newUser.PHONE,
          BRANCH_CODE: newUser.BRANCH_CODE.split("-")[0],
          BANK_CODE: newUser.BRANCH_CODE.split("-")[1],
          USER_CATEGORY_ID: newUser.USER_CATEGORY_ID,
          PROFILE_PIC: newUser.PROFILE_PIC ? newUser.PROFILE_PIC : "",
          SIGNATURE_IMAGE: newUser.SIGNATURE_IMAGE
            ? newUser.SIGNATURE_IMAGE
            : "",
          BIO_INFO: newUser.BIO_INFO ? newUser.BIO_INFO : "BIO_INFO",
          STATUS: newUser.STATUS ? newUser.STATUS : "ACTIVE",
          APPROVED_BY: newUser.APPROVED_BY,
          APPROVE_AMT_LIMIT: newUser.APPROVE_AMT_LIMIT
            ? newUser.APPROVE_AMT_LIMIT
            : 0,
          UPDATED_BY: JSON.parse(sessionStorage.getItem("user")).ID,
        },
        _data,
      )
      .then(({ data }) => {
        //console.log("user data:", data);
        // console.log('success');
        //sessionStorage.setItem("createResp", 'success');
        //dispatch({type: FETCH_SUCCESS});
        // alert(JSON.stringify(store.getState().auth.authUser))
        let userInfo = store.getState().auth.authUser;
        userInfo.FORCE_CHANGE_PASSWORD = 0;
        sessionStorage.setItem("user", JSON.stringify(userInfo));
        dispatch({ type: USER_DATA, payload: userInfo });
        // dispatch({type: SHOW_MESSAGE, payload: "Password changed successfully"});

        // delete data.PROFILE_PIC;
        // delete data.SIGNATURE_IMAGE;
        if (data) {
          sessionStorage.setItem("successChangePass", "true");
        }
        //alert(JSON.stringify(data));
        //dispatch(userSignOut)
        //alert(JSON.stringify(store.getState().auth.authUser))
      })
      .catch(function (error) {
        //console.log("user data Failed: ");
        //sessionStorage.setItem("createResp", 'error');
        if (error) {
          sessionStorage.setItem("successChangePass", "false");
        }
        dispatch({ type: FETCH_ERROR, payload: "Failed to change password" });
        //console.log("Error****:", error.message);
      });
  };
};
